import SairaRegular from './Saira-Regular.ttf';
import SairaBold from './Saira-Bold.ttf';

// Los estilos del documento piden fontFamily "Saira". @react-pdf sólo conoce
// Helvetica, Courier y Times: si no se registra, la generación falla. En la app
// anterior el registro vivía en el llamador, no en el componente, y al copiar
// sólo el componente se quedó fuera.
let fontsReady = false;

async function registerFonts(Font) {
  if (fontsReady) return;
  Font.register({
    family: 'Saira',
    fonts: [
      { src: SairaRegular },
      { src: SairaBold, fontWeight: 'bold' },
    ],
  });
  fontsReady = true;
}

// Genera el PDF en el navegador y lo descarga. La librería se carga bajo
// demanda: son ~440 kB que no tienen por qué bajar en cada visita.
export async function downloadQuotePdf(quote, { onError } = {}) {
  try {
    const { pdf, Font } = await import('@react-pdf/renderer');
    const { default: QuotePdf } = await import('./QuotePdf');
    const { createElement } = await import('react');
    const { makeTranslator } = await import('../../i18n');

    await registerFonts(Font);
    const blob = await pdf(
      createElement(QuotePdf, { QuoteData: quote, t: makeTranslator() })
    ).toBlob();
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `cotizacion-${quote.q_folio ?? 'mp'}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();

    // Se libera en el siguiente ciclo: revocarla de inmediato cancela la
    // descarga en algunos navegadores.
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return true;
  } catch (err) {
    console.error('downloadQuotePdf:', err);
    if (onError) onError(err);
    return false;
  }
}

// El mismo blob, en base64, para adjuntarlo al correo.
export async function quotePdfBase64(quote) {
  const { pdf, Font } = await import('@react-pdf/renderer');
  const { default: QuotePdf } = await import('./QuotePdf');
  const { createElement } = await import('react');
  const { makeTranslator } = await import('../../i18n');

  await registerFonts(Font);
  const blob = await pdf(
    createElement(QuotePdf, { QuoteData: quote, t: makeTranslator() })
  ).toBlob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1]);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
